const SEPARATORS = /[/\s:_-]+/;
const SHORT_NUMBER = /^(?:0|[1-9]\d?)$/;
const DOTTED_NUMBER = /^\d+(?:\.\d+)+$/;
const SIZE_TOKEN = /^(\d+(?:\.\d+)?)([bk])$/i;
const ACRONYMS = new Set(["ai", "baai", "bge", "gpt", "hd", "llm", "ocr", "tts", "vl"]);

/**
 * Human label for a raw model id. Slashes and word separators become spaces.
 * A run of version segments becomes a dotted version (`5-5` → `5.5`, `3-0` → `3.0`).
 * A segment is one or two digits and must not have a leading zero, so a date like
 * `2026-03-03` stays `2026 03 03`. A segment that already contains a dot (`5.5`, `3.1`)
 * is left as one number. Longer digit runs (dates like `20250929`, snapshots like `0125`)
 * stay separate.
 * The technical id used in API requests is not modified here.
 */
export function formatModelLabel(value) {
  const source = typeof value === "string" ? value.trim() : "";
  if (!source) return "";

  const tokens = source.split(SEPARATORS).filter(Boolean);
  const parts = [];
  for (let index = 0; index < tokens.length; index += 1) {
    if (!SHORT_NUMBER.test(tokens[index])) {
      parts.push(presentToken(tokens[index]));
      continue;
    }
    const version = [tokens[index]];
    let next = index + 1;
    while (next < tokens.length && SHORT_NUMBER.test(tokens[next])) {
      version.push(tokens[next]);
      next += 1;
    }
    parts.push(version.length > 1 ? version.join(".") : version[0]);
    index = next - 1;
  }
  return parts.join(" ");
}

function presentToken(token) {
  const size = token.match(SIZE_TOKEN);
  if (size) return `${size[1]}${size[2].toUpperCase()}`;
  if (DOTTED_NUMBER.test(token)) return token;
  if (/[A-Z]/.test(token) && !/[a-z]/.test(token)) return token;
  if (ACRONYMS.has(token.toLowerCase())) return token.toUpperCase();
  if (/^[a-z]{1,3}\d+(?:\.\d+)?[a-z]{0,2}$/i.test(token)) {
    return token.replace(/[a-z]/gi, (letter) => letter.toUpperCase());
  }
  return token.charAt(0).toUpperCase() + token.slice(1);
}
